<template>
  <section v-if="active" class="app-modal__section">
    <header class="app-modal__section-head">
      <h4>{{ text.modal.form.bankData.title }}</h4>
      <p>{{ text.modal.form.bankData.subtitle }}</p>
    </header>

    <div class="app-modal__grid two-columns">
      <label class="app-modal-field">
        <span>{{ text.modal.form.bankData.fields.beneficiaryBankRfc }}</span>
        <input
          v-model.trim="form.beneficiaryBankRfc"
          type="text"
          class="form-control"
          autocomplete="off"
          :placeholder="text.modal.form.bankData.placeholders.beneficiaryBankRfc || 'Captura RFC del banco beneficiario'"
        />
      </label>

      <label class="app-modal-field">
        <span>{{ text.modal.form.bankData.fields.paymentAccount }}</span>
        <input
          v-model.trim="form.paymentAccount"
          type="text"
          class="form-control"
          autocomplete="off"
          :placeholder="text.modal.form.bankData.placeholders.paymentAccount || 'Captura numero de cuenta beneficiario'"
        />
      </label>

      <label class="app-modal-field">
        <span>{{ text.modal.form.bankData.fields.orderingBank }}</span>
        <input
          v-model.trim="form.orderingBank"
          type="text"
          class="form-control"
          autocomplete="off"
          :placeholder="text.modal.form.bankData.placeholders.orderingBank || 'Captura banco ordenante'"
        />
      </label>

      <label class="app-modal-field">
        <span>{{ text.modal.form.bankData.fields.orderingBankRfc }}</span>
        <input
          v-model.trim="form.orderingBankRfc"
          type="text"
          class="form-control"
          autocomplete="off"
          :placeholder="text.modal.form.bankData.placeholders.orderingBankRfc || 'Captura RFC del banco'"
        />
      </label>

      <label class="app-modal-field">
        <span>{{ text.modal.form.bankData.fields.orderingBankAccount }}</span>
        <input
          v-model.trim="form.orderingBankAccount"
          type="text"
          class="form-control"
          autocomplete="off"
          :placeholder="text.modal.form.bankData.placeholders.orderingBankAccount || 'Captura cuenta ordenante'"
        />
      </label>
    </div>
  </section>
</template>

<script>
import { useDomainText } from '@/composables/text/useDomainText';

const { catalog: text } = useDomainText('billingData');

export default {
  name: 'ContributorSectionBankData',
  data() {
    return {
      text,
    };
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      required: true,
    },
    v$: {
      type: Object,
      default: null,
    },
  },
};
</script>
